import { Injectable } from '@angular/core';
import * as jwt from 'jwt-simple';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MockAuthService {
  private readonly mockUser = environment.mockUser;
  private readonly mockPassword = environment.mockPassword;
  private readonly jwtSecret = environment.jwtSecret;
  private readonly jwtClaims = environment.jwtClaims;

  login(username: string, password: string): boolean {
    if (username === this.mockUser && password === this.mockPassword) {
      const token = jwt.encode({ username, password }, this.jwtSecret);
      localStorage.setItem('token', token); // <=== We store this in local storage so we can look it up later.
      return true;
    }
    return false;
  }

  logout(): void {
    localStorage.removeItem('token');
  }

  isAuthenticated(): boolean {
    return localStorage.getItem('token') !== null;
  }

  // We need this to get the token on other requests
  getToken(): string | null {
    return localStorage.getItem('token');
  }
}
